

































import { defineComponent, reactive, ref } from '@vue/composition-api';

import { approvePurchaseOrder } from '@/api';
import usePurchaseOrder from '@/use/usePurchaseOrder';

const CommonModalWithApprovePurchaseOrder = defineComponent({
  setup(props, { emit }) {
    const { statusClassMap, statusTranslate } = usePurchaseOrder();
    const modal = ref(null);
    const purchaseOrder = ref({
      id: -1, approved: false, manager_approved: false, chief_manager_approved: false,
    });
    function open(purchaseOrderFn: any) {
      purchaseOrder.value = purchaseOrderFn;
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }
    const form = reactive({
      approve: true,
      reason: '',
      level: 'STAFF',
      call: async () => {
        const level = purchaseOrder.value.approved ? (purchaseOrder.value.manager_approved ? 'CHIEF' : 'MANAGER') : 'STAFF';
        await approvePurchaseOrder(purchaseOrder.value.id, {
          approve: form.approve,
          reason: form.reason,
          level,
        });
        emit('done');
        close();
      },
      statue: {
        value: 'READY',
      },
    });

    function approvedInput(val: boolean) {
      form.approve = val;
    }

    return {
      approvedInput,
      statusClassMap,
      statusTranslate,
      form,
      modal,
      purchaseOrder,
      open,
      close,
    };
  },
});

export default CommonModalWithApprovePurchaseOrder;
